import { useState, useEffect } from "react";
import { deref } from "kanopi-components/utils/primitives";

import api from "kw/api";
import { RiskStateFilterEnum } from "kw/api/zeus";

import { substituteRiskData } from "../substituteRiskData";

type TUseRiskState = {
  riskProfileId: bigint;
  filterBy?: RiskStateFilterEnum;
};

export function useRiskState(args: TUseRiskState) {
  const { riskProfileId, filterBy } = args || {};
  const [loading, setLoading] = useState(true);
  const [riskState, setRiskState] = useState();
  async function fetch() {
    setLoading(true);
    try {
      const [questionSets, riskProfile] = await queryRiskState(riskProfileId, filterBy);
      setRiskState({ questionSets, riskProfile });
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (riskProfileId) fetch();
  }, [riskProfileId]);
  return [riskState, { loading }];
}

async function queryRiskState(riskProfileId, filterBy) {
  const response = await api.query(getRiskStateQuery(riskProfileId, filterBy));
  // TODO: This is ugly. I'd love to factor out the questionSet and
  // riskProfile subtitutions away from the enquiry. Or, better yet,
  // we should move this to the server. This is actually the second
  // instance of this. +1 to priority.
  const results = [];
  let finalRiskProfile;
  for (const questionSet of deref(response, "riskState.questionSets", [])) {
    const [enquiry, riskProfile] = substituteRiskData(
      {
        questionSet,
      },
      deref(response, "riskState.riskProfile", {})
    );
    results.push(enquiry.questionSet);
    finalRiskProfile = riskProfile;
  }
  return [results, finalRiskProfile];
}

function getRiskStateQuery(riskProfileId, filterBy?: RiskStateFilterEnum) {
  return {
    riskState: [
      {
        riskProfileId,
        filterBy: filterBy,
      },
      {
        riskProfile: {
          id: true,
          riskData: true,
        },
        questionSets: {
          id: true,
          title: true,
          description: true,
          key: true,
          questions: {
            id: true,
            help: true,
            label: true,
            displayLabel: true,
            inputType: true,
            inputArgs: true,
            storagePath: true,
            order: true,
            validators: true,
            default: true,
          },
          order: true,
        },
      },
    ],
  };
}
